module.exports = __webpack_public_path__ + "img/shouye-gongjice-png.6aa859a4.svg";